"use strict";

exports.__esModule = true;
exports.StyledProgressIndicator = exports.ProgressIndicatorLabel = exports.ProgressIndicatorChartTrack = exports.ProgressIndicatorChartLabel = exports.ProgressIndicatorChartBar = exports.ProgressIndicatorChart = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ProgressIndicatorChart = (0, _styledComponents.default)(({
  radius,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...props
}))`
    position: relative;
    width: ${props => props.radius * 2}px;
    height: ${props => props.radius * 2}px;

    svg {
        position: relative;
        transform: rotate(-90deg);
        width: ${props => props.radius * 2}px;
        height: ${props => props.radius * 2}px;
    }
`;
exports.ProgressIndicatorChart = ProgressIndicatorChart;
const ProgressIndicatorChartBar = _styledComponents.default.circle`
    position: absolute;
    transition: stroke-dashoffset 0.35s;
    transform-origin: 50% 50%;
    stroke: ${props => props.barColor ? props.barColor : props.theme.colors.progressIndicator.bar};
`;
exports.ProgressIndicatorChartBar = ProgressIndicatorChartBar;
const ProgressIndicatorChartTrack = _styledComponents.default.circle`
    stroke: ${props => props.trackColor ? props.trackColor : props.theme.colors.progressIndicator.track};
`;
exports.ProgressIndicatorChartTrack = ProgressIndicatorChartTrack;
const ProgressIndicatorChartLabel = _styledComponents.default.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: ${props => props.theme.colors.progressIndicator.value};
    font-weight: ${props => props.theme.fontWeights.light};
`;
exports.ProgressIndicatorChartLabel = ProgressIndicatorChartLabel;
const ProgressIndicatorLabel = _styledComponents.default.div`
    font-weight: ${props => props.theme.fontWeights.regular};
    text-align: center;
    color: ${props => props.theme.colors.progressIndicator.label};
`;
exports.ProgressIndicatorLabel = ProgressIndicatorLabel;
const StyledProgressIndicator = (0, _styledComponents.default)(({
  radius,
  valueColor,
  labelColor,
  barColor,
  trackColor,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...props
}))`
    width: ${props => props.radius * 2}px;

    ${props => props.valueColor && (0, _styledComponents.css)`
        ${ProgressIndicatorChartLabel} {
            color: ${props => props.valueColor};
        }
    `}

    ${props => props.labelColor && (0, _styledComponents.css)`
        ${ProgressIndicatorLabel} {
            color: ${props => props.labelColor};
        }
    `}
    
`;
exports.StyledProgressIndicator = StyledProgressIndicator;